import { render, staticRenderFns } from "./PlotStatement.vue?vue&type=template&id=189e6bf4"
import script from "./PlotStatement.vue?vue&type=script&lang=js"
export * from "./PlotStatement.vue?vue&type=script&lang=js"
import style0 from "./PlotStatement.vue?vue&type=style&index=0&id=189e6bf4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports